import { useMutation } from '@tanstack/react-query';
import { BarcodeApi } from 'api';

/**
 * [QR] QR URL 생성
 * --
 */
export const useCreateQRCodeURL = (options) => {
  const { mutateAsync: createQRUrl, ...result } = useMutation({
    mutationFn: (variables) => BarcodeApi.createQRUrl(variables),
    ...options,
  });
  return { createQRUrl, ...result };
};

/**
 * [QR] QR String 생성
 * --
 */
export const useCreateQRCodeString = (options) => {
  const { mutateAsync: createQRString, ...result } = useMutation({
    mutationFn: (variables) => BarcodeApi.createQRString(variables),
    ...options,
  });
  return { createQRString, ...result };
};

/**
 * [QR] QR Buffer 생성
 * --
 */
export const useCreateQRCodeBuffer = (options) => {
  const { mutateAsync: createQRBuffer, ...result } = useMutation({
    mutationFn: (variables) => BarcodeApi.createQRBuffer(variables),
    ...options,
  });
  return { createQRBuffer, ...result };
};

/**
 * [Barcode] Barcode URL 생성
 * --
 */
export const useCreateBarcodeURL = (options) => {
  const { mutateAsync: createBarcodeUrl, ...result } = useMutation({
    mutationFn: (variables) => BarcodeApi.createBarcodeUrl(variables),
    ...options,
  });
  return { createBarcodeUrl, ...result };
};

/**
 * [Barcode] Barcode Buffer 생성
 * --
 */
export const useCreateBarcodeBuffer = (options) => {
  const { mutateAsync: createBarcodeBuffer, ...result } = useMutation({
    mutationFn: (variables) => BarcodeApi.createBarcodeBuffer(variables),
    ...options,
  });
  return { createBarcodeBuffer, ...result };
};
